<template lang="pug">
div
  app-divider.negative-margin-top.margin-bottom(
    :label="getLabelDados",
  )
  div.column(v-if="isAp"
    type="flex",
    justify="space-between",
  )
    el-col(:span="6")
      app-label(label="O processo terá custas:")
      el-row(type="flex")
        el-radio-group(v-model='teraCustas')
          el-radio(:label="true") Sim
          el-radio(:label="false") Não (Isento)
    el-row(
      v-if="teraCustas"
      type="flex",
      justify="space-between",
      :gutter="30"
    )
      el-col(:span="6")
        app-label(label="Valor do boleto:")
        validation-provider(rules="required", v-slot="{ errors }")
          app-double-input.input(
            v-model='dadosBoletoDespacho.valorDae',
            :class="{'erro' : errors.length}",
            prefix='R$ '
          )
          span.help.erro {{ errors[0] }}

      el-col(:span="6")
        app-label(label="Número do boleto:")
        validation-provider(rules="required|numeroDae", v-slot="{ errors }")
          el-input.input(
            v-model="dadosBoletoDespacho.numeroDae",
            :maxlength= "60",
            v-mask="'############################################################'",
            :class="{'erro' : errors.length}",
            name="numeroDae",
            data-vv-validate-on="change",
            data-vv-delay="5"
          )
          span.help.erro {{ errors[0] }}

      el-col(:span="6")
        app-label(label="Data de Vencimento:")
        validation-provider(rules="required", v-slot="{ errors }")
          el-date-picker.input.full-width(
            v-model="dadosBoletoDespacho.dataVencimento",
            placeholder='Selecione',
            format="dd/MM/yyyy",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}

      el-col(:span="6")
        validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="Município:")
            el-select.full-width.input(
              v-model='idMunicipio'
              :class="{'erro' : errors.length}"
              @change="setDadosMunicipio"
            )
              el-option(
                  v-for='municipio in municipios'
                  :key='municipio.id',
                  :label='municipio.nome'
                  :value='municipio.id'
              )
            span.help.erro {{ errors[0] }}
  el-row(
    v-else
    type="flex",
    justify="space-between",
    :gutter="30"
  )
    el-col(:span="6")
      app-label(label="Valor do DAE")
      validation-provider(rules="required", v-slot="{ errors }")
        app-double-input.input(
          v-model='dadosBoletoDespacho.valorDae',
          :class="{'erro' : errors.length}",
          prefix='R$ '
        )
        span.help.erro {{ errors[0] }}

    el-col(:span="6")
      app-label(label="Número do DAE")
      validation-provider(rules="required|numeroDae", v-slot="{ errors }")
        el-input.input(
          v-model="dadosBoletoDespacho.numeroDae",
          :maxlength= "60",
          v-mask="'############################################################'",
          :class="{'erro' : errors.length}",
          name="numeroDae",
          data-vv-validate-on="change",
          data-vv-delay="5"
        )
        span.help.erro {{ errors[0] }}

    el-col(:span="6")
      app-label(label="Data de Vencimento")
      validation-provider(rules="required|dateAfterToday", v-slot="{ errors }")
        el-date-picker.input.full-width(
          v-model="dadosBoletoDespacho.dataVencimento",
          placeholder='Selecione',
          :picker-options='options',
          format="dd/MM/yyyy",
          :class="{'erro' : errors.length}"
        )
        span.help.erro {{ errors[0] }}

    el-col(:span="6")
      validation-provider(rules="required", v-slot="{ errors }")
          app-label(label="Município:")
          el-select.full-width.input(
            v-model='idMunicipio'
            :class="{'erro' : errors.length}"
            @change="setDadosMunicipio"
          )
            el-option(
                v-for='municipio in municipios'
                :key='municipio.id',
                :label='municipio.nome'
                :value='municipio.id'
            )
          span.help.erro {{ errors[0] }}

</template>

<script>
import { mapActions } from 'vuex'
import AppLabel from './AppLabel'
import AppAnexo from './AppAnexo'
import AppDivider from '@/components/AppDivider'
import AppDoubleInput from '@/components/AppDoubleInput'

export default {

  components: {
    AppLabel,
    AppAnexo,
    AppDivider,
    AppDoubleInput
  },

  data () {
    return {
      idMunicipio: null,
      municipios: null,
      options: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      },
      isAp: process.env.ESTADO === 'ap',
      teraCustas: false
    }
  },

  props: {
    dadosBoletoDespacho: {
      type: Object,
      required: true
    }
  },

  async created () {
    this.municipios = await this.findMunicipiosByEstadoAtual() || []
    this.idMunicipio = this.dadosBoletoDespacho.municipio?.id
    if (this.isAp) {
      this.teraCustas = !this.dadosBoletoDespacho?.isentoDae
      if (![true, false].includes(this.dadosBoletoDespacho?.isentoDae)) {
        this.dadosBoletoDespacho['isentoDae'] = true
      }
    }
  },

  computed: {
    getLabelDados () {
      return this.isAp ? 'Dados das Custas' : 'Dados DAE'
    }
  },

  methods: {
    ...mapActions({
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtualPromise'
    }),

    setDadosMunicipio () {
      this.dadosBoletoDespacho.municipio = {
        id: this.idMunicipio
      }
    },

    limparDadosBoleto () {
      this.dadosBoletoDespacho.valorDae = null
      this.dadosBoletoDespacho.numeroDae = null
      this.dadosBoletoDespacho.dataVencimento = null
      this.dadosBoletoDespacho.municipio = null
      this.idMunicipio = null
    }
  },

  watch: {
    teraCustas: {
      handler (val) {
        if (val === false) {
          this.limparDadosBoleto()
        }
        if ('isentoDae' in this.dadosBoletoDespacho) {
          this.dadosBoletoDespacho.isentoDae = !val
        } else {
          this.dadosBoletoDespacho['isentoDae'] = !val
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
.full-width {
  width: -webkit-fill-available;
}

.margin-bottom {
  margin-bottom: 20px;
}

.negative-margin-top {
  margin-top: -25px;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 20px
}
</style>



// WEBPACK FOOTER //
// src/components/AppEmitirDaeExterno.vue